import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { PlaceholderMockup } from './ui/PlaceholderMockup';
import { proofStats, insideScreenshots } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ProofSection() {
  const featured = insideScreenshots.slice(0, 4);
  return <section className="bg-mp-dark py-20 md:py-28" data-id="element-287" data-mp="39z8aiodgdye5">
      <Container data-id="element-288" data-mp="3e1lasx9fl43j">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-289" data-mp="3e13btsvdwbrx">
          <SectionTag tone="white" data-id="element-290" data-mp="3dz8m81963vhi">No promesas. Contenido.</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-291" data-mp="3isv2e3ejihi2">
            Un sistema que puedes ver antes de comprar.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-4 md:grid-cols-7" data-id="element-292" data-mp="3ss2fqql9yc56">
          {proofStats.map((stat, i) => <motion.div key={stat.copy} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.35,
          ease: easeOut,
          delay: i % 4 * 0.05
        }} className="rounded-xl border border-mp-border bg-mp-card p-4 text-center" data-id="element-293" data-mp="1htvk8tosjty" data-mpi={i}>
              <p className="font-heading text-2xl text-mp-lime sm:text-3xl" data-id="element-294" data-mp="rptf2c97r4fk">{stat.title}</p>
              <p className="mt-1 text-[11px] uppercase tracking-wide text-mp-gray sm:text-xs" data-id="element-295" data-mp="1og3um12gbw3m">{stat.copy}</p>
            </motion.div>)}
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-296" data-mp="1en4tjjprqd34">
          {featured.map(label => <PlaceholderMockup key={label} label={label} aspect="aspect-[4/3]" data-id="element-297" data-mp="1altci2kyn06j" />)}
        </div>
      </Container>
    </section>;
}